var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddKeyframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.7 59.6c-6.3-6.3-6.3-16.4 0-22.6l28.3-28.3c6.2-6.3 16.3-6.3 22.6 0l28.3 28.3c6.2 6.2 6.2 16.3 0 22.6l-28.3 28.3c-6.3 6.2-16.4 6.2-22.6 0zm45.3-27.6c0-3.3-2.7-6-6-6-3.3 0-6 2.7-6 6v10h-10c-3.3 0-6 2.7-6 6 0 3.3 2.7 6 6 6h10v10c0 3.3 2.7 6 6 6 3.3 0 6-2.7 6-6v-10h10c3.3 0 6-2.7 6-6 0-3.3-2.7-6-6-6h-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddKeyframe);
export default __webpack_public_path__ + "static/media/add-keyframe.0bb51253862c67af1388174f8a7aa905.svg";
export { ForwardRef as ReactComponent };